import { getFlag } from "@/config/rdoFlags";
import { VideosModule } from "@/components/rdo/modules/VideosModule";
import { LegacyVideosSection } from "@/components/rdo/legacy/LegacyVideosSection";
import { normalizeFromRDOPAGE, toRDOPAGEPayload } from "@/domain/rdo/normalize";
import type { RDO } from "@/domain/rdo/schema";

export function VideosForRDO({
  legacyValue,
  onLegacyChange,
  mode
}: {
  legacyValue: any;                 // shape atual usado em RDO.tsx (videos)
  onLegacyChange: (v: any) => void; // setter do RDO.tsx
  mode: "edit" | "view";
}) {
  if (!getFlag("useNewVideosInRDO")) {
    // Render legado de Vídeos (manter como está)
    return <LegacyVideosSection value={legacyValue} onChange={onLegacyChange} mode={mode} />;
  }

  // 1) Converte do legado -> RDO (somente videos)
  const rdoData = {
    id: "",
    obraId: "",
    date: "",
    workforce: [],
    equipment: [],
    activities: [],
    occurrences: [],
    materials: { received: [], used: [] },
    comments: [],
    photos: [],
    videos: legacyValue || [],
    attachments: [],
    status: "draft" as const,
    createdAt: "",
    updatedAt: ""
  };
  const rdo: Partial<RDO> = normalizeFromRDOPAGE(rdoData);

  // 2) Renderiza o módulo novo com a UX do Preenchendo
  return (
    <VideosModule
      value={rdo.videos || []}
      mode={mode === "view" ? "view" : "edit"}
      onChange={(videos) => {
        // 3) Converte de volta p/ o payload legado
        const payload = toRDOPAGEPayload({ ...rdo, videos } as RDO);
        onLegacyChange(payload.videos);
      }}
    />
  );
}